/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-Pay Payment API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CodeDescriptionRestDto } from '../models';
import { PaymentProviderSettingsRestDto } from '../models';
import { PaymentProviderWebhookInfoRestDto } from '../models';
import { WorldlinePaymentProviderSettingsRestDto } from '../models';
/**
 * PaymentProviderEndpointsApi - axios parameter creator
 * @export
 */
export const PaymentProviderEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Disconnect payment provider from pharmacy
         * @summary REST.API.PAY.PROVIDER.04 Disconnect payment provider
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectPaymentProvider: async (x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling disconnectPaymentProvider.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling disconnectPaymentProvider.');
            }
            // verify required parameter 'payment_provider_code' is not null or undefined
            if (payment_provider_code === null || payment_provider_code === undefined) {
                throw new RequiredError('payment_provider_code','Required parameter payment_provider_code was null or undefined when calling disconnectPaymentProvider.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider/{payment_provider_code}/settings`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)))
                .replace(`{${"payment_provider_code"}}`, encodeURIComponent(String(payment_provider_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect Worldline payment provider from pharmacy
         * @summary REST.API.PAY.PROVIDER.07 Disconnect Worldline payment provider
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectWorldlinePaymentProvider: async (x_dp_customer_code: string, pharmacy_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling disconnectWorldlinePaymentProvider.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling disconnectWorldlinePaymentProvider.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider/WORLDLINE/settings`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get available payment providers
         * @summary REST.API.PAY.PROVIDER.01 Get available payment providers.
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailablePaymentProviders: async (x_dp_customer_code: string, pharmacy_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling getAvailablePaymentProviders.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling getAvailablePaymentProviders.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payment provider settings
         * @summary REST.API.PAY.PROVIDER.02 Get payment provider settings
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentProviderSettings: async (x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling getPaymentProviderSettings.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling getPaymentProviderSettings.');
            }
            // verify required parameter 'payment_provider_code' is not null or undefined
            if (payment_provider_code === null || payment_provider_code === undefined) {
                throw new RequiredError('payment_provider_code','Required parameter payment_provider_code was null or undefined when calling getPaymentProviderSettings.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider/{payment_provider_code}/settings`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)))
                .replace(`{${"payment_provider_code"}}`, encodeURIComponent(String(payment_provider_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get payment provider webhook info
         * @summary REST.API.PAY.PROVIDER.08 Get payment provider webhook info
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentProviderWebhookInfo: async (x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling getPaymentProviderWebhookInfo.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling getPaymentProviderWebhookInfo.');
            }
            // verify required parameter 'payment_provider_code' is not null or undefined
            if (payment_provider_code === null || payment_provider_code === undefined) {
                throw new RequiredError('payment_provider_code','Required parameter payment_provider_code was null or undefined when calling getPaymentProviderWebhookInfo.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider/{payment_provider_code}/webhook_info`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)))
                .replace(`{${"payment_provider_code"}}`, encodeURIComponent(String(payment_provider_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Worldline payment provider settings
         * @summary REST.API.PAY.PROVIDER.05 Get Worldline payment provider settings
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorldlinePaymentProviderSettings: async (x_dp_customer_code: string, pharmacy_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling getWorldlinePaymentProviderSettings.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling getWorldlinePaymentProviderSettings.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider/WORLDLINE/settings`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update payment provider settings
         * @summary REST.API.PAY.PROVIDER.03 Update payment provider settings
         * @param {PaymentProviderSettingsRestDto} body 
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentProviderSettings: async (body: PaymentProviderSettingsRestDto, x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePaymentProviderSettings.');
            }
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling updatePaymentProviderSettings.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling updatePaymentProviderSettings.');
            }
            // verify required parameter 'payment_provider_code' is not null or undefined
            if (payment_provider_code === null || payment_provider_code === undefined) {
                throw new RequiredError('payment_provider_code','Required parameter payment_provider_code was null or undefined when calling updatePaymentProviderSettings.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider/{payment_provider_code}/settings`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)))
                .replace(`{${"payment_provider_code"}}`, encodeURIComponent(String(payment_provider_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Worldline payment provider settings
         * @summary REST.API.PAY.PROVIDER.06 Update Worldline payment provider settings
         * @param {WorldlinePaymentProviderSettingsRestDto} body 
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorldlinePaymentProviderSettings: async (body: WorldlinePaymentProviderSettingsRestDto, x_dp_customer_code: string, pharmacy_code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateWorldlinePaymentProviderSettings.');
            }
            // verify required parameter 'x_dp_customer_code' is not null or undefined
            if (x_dp_customer_code === null || x_dp_customer_code === undefined) {
                throw new RequiredError('x_dp_customer_code','Required parameter x_dp_customer_code was null or undefined when calling updateWorldlinePaymentProviderSettings.');
            }
            // verify required parameter 'pharmacy_code' is not null or undefined
            if (pharmacy_code === null || pharmacy_code === undefined) {
                throw new RequiredError('pharmacy_code','Required parameter pharmacy_code was null or undefined when calling updateWorldlinePaymentProviderSettings.');
            }
            const localVarPath = `/payment/v1/pharmacy/{pharmacy_code}/payment_provider/WORLDLINE/settings`
                .replace(`{${"pharmacy_code"}}`, encodeURIComponent(String(pharmacy_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentProviderEndpointsApi - functional programming interface
 * @export
 */
export const PaymentProviderEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Disconnect payment provider from pharmacy
         * @summary REST.API.PAY.PROVIDER.04 Disconnect payment provider
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectPaymentProvider(_axios: AxiosInstance, x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).disconnectPaymentProvider(x_dp_customer_code, pharmacy_code, payment_provider_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Disconnect Worldline payment provider from pharmacy
         * @summary REST.API.PAY.PROVIDER.07 Disconnect Worldline payment provider
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectWorldlinePaymentProvider(_axios: AxiosInstance, x_dp_customer_code: string, pharmacy_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).disconnectWorldlinePaymentProvider(x_dp_customer_code, pharmacy_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get available payment providers
         * @summary REST.API.PAY.PROVIDER.01 Get available payment providers.
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailablePaymentProviders(_axios: AxiosInstance, x_dp_customer_code: string, pharmacy_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CodeDescriptionRestDto>>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).getAvailablePaymentProviders(x_dp_customer_code, pharmacy_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get payment provider settings
         * @summary REST.API.PAY.PROVIDER.02 Get payment provider settings
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentProviderSettings(_axios: AxiosInstance, x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentProviderSettingsRestDto>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).getPaymentProviderSettings(x_dp_customer_code, pharmacy_code, payment_provider_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get payment provider webhook info
         * @summary REST.API.PAY.PROVIDER.08 Get payment provider webhook info
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentProviderWebhookInfo(_axios: AxiosInstance, x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentProviderWebhookInfoRestDto>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).getPaymentProviderWebhookInfo(x_dp_customer_code, pharmacy_code, payment_provider_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get Worldline payment provider settings
         * @summary REST.API.PAY.PROVIDER.05 Get Worldline payment provider settings
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorldlinePaymentProviderSettings(_axios: AxiosInstance, x_dp_customer_code: string, pharmacy_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorldlinePaymentProviderSettingsRestDto>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).getWorldlinePaymentProviderSettings(x_dp_customer_code, pharmacy_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update payment provider settings
         * @summary REST.API.PAY.PROVIDER.03 Update payment provider settings
         * @param {PaymentProviderSettingsRestDto} body 
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {string} payment_provider_code The code of the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentProviderSettings(_axios: AxiosInstance, body: PaymentProviderSettingsRestDto, x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).updatePaymentProviderSettings(body, x_dp_customer_code, pharmacy_code, payment_provider_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update Worldline payment provider settings
         * @summary REST.API.PAY.PROVIDER.06 Update Worldline payment provider settings
         * @param {WorldlinePaymentProviderSettingsRestDto} body 
         * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
         * @param {string} pharmacy_code The code of the pharmacy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorldlinePaymentProviderSettings(_axios: AxiosInstance, body: WorldlinePaymentProviderSettingsRestDto, x_dp_customer_code: string, pharmacy_code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PaymentProviderEndpointsApiAxiosParamCreator(configuration).updateWorldlinePaymentProviderSettings(body, x_dp_customer_code, pharmacy_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PaymentProviderEndpointsApi - object-oriented interface
 * @export
 * @class PaymentProviderEndpointsApi
 * @extends {BaseAPI}
 */
export class PaymentProviderEndpointsApi extends BaseAPI {
    /**
     * Disconnect payment provider from pharmacy
     * @summary REST.API.PAY.PROVIDER.04 Disconnect payment provider
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {string} payment_provider_code The code of the payment provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public disconnectPaymentProvider(x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).disconnectPaymentProvider(this.axios, x_dp_customer_code, pharmacy_code, payment_provider_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect Worldline payment provider from pharmacy
     * @summary REST.API.PAY.PROVIDER.07 Disconnect Worldline payment provider
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public disconnectWorldlinePaymentProvider(x_dp_customer_code: string, pharmacy_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).disconnectWorldlinePaymentProvider(this.axios, x_dp_customer_code, pharmacy_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get available payment providers
     * @summary REST.API.PAY.PROVIDER.01 Get available payment providers.
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public getAvailablePaymentProviders(x_dp_customer_code: string, pharmacy_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).getAvailablePaymentProviders(this.axios, x_dp_customer_code, pharmacy_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payment provider settings
     * @summary REST.API.PAY.PROVIDER.02 Get payment provider settings
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {string} payment_provider_code The code of the payment provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public getPaymentProviderSettings(x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).getPaymentProviderSettings(this.axios, x_dp_customer_code, pharmacy_code, payment_provider_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get payment provider webhook info
     * @summary REST.API.PAY.PROVIDER.08 Get payment provider webhook info
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {string} payment_provider_code The code of the payment provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public getPaymentProviderWebhookInfo(x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).getPaymentProviderWebhookInfo(this.axios, x_dp_customer_code, pharmacy_code, payment_provider_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Worldline payment provider settings
     * @summary REST.API.PAY.PROVIDER.05 Get Worldline payment provider settings
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public getWorldlinePaymentProviderSettings(x_dp_customer_code: string, pharmacy_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).getWorldlinePaymentProviderSettings(this.axios, x_dp_customer_code, pharmacy_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update payment provider settings
     * @summary REST.API.PAY.PROVIDER.03 Update payment provider settings
     * @param {PaymentProviderSettingsRestDto} body 
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {string} payment_provider_code The code of the payment provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public updatePaymentProviderSettings(body: PaymentProviderSettingsRestDto, x_dp_customer_code: string, pharmacy_code: string, payment_provider_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).updatePaymentProviderSettings(this.axios, body, x_dp_customer_code, pharmacy_code, payment_provider_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Worldline payment provider settings
     * @summary REST.API.PAY.PROVIDER.06 Update Worldline payment provider settings
     * @param {WorldlinePaymentProviderSettingsRestDto} body 
     * @param {string} x_dp_customer_code Code that uniquely identifies the Digital Pharma customer.
     * @param {string} pharmacy_code The code of the pharmacy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderEndpointsApi
     */
     public updateWorldlinePaymentProviderSettings(body: WorldlinePaymentProviderSettingsRestDto, x_dp_customer_code: string, pharmacy_code: string, options?: any) {
        return PaymentProviderEndpointsApiFp(this.configuration).updateWorldlinePaymentProviderSettings(this.axios, body, x_dp_customer_code, pharmacy_code, options).then((request) => request(this.axios, this.basePath));
    }

}
